import { DEFAULT_MODEL } from '../../store/types.ts';

type SettingsModalProps = {
  open: boolean;
  model: string;
  onClose: () => void;
  onUpdateModel: (model: string) => void;
  onRerunOnboarding: () => void;
};

export function SettingsModal({
  open,
  model,
  onClose,
  onUpdateModel,
  onRerunOnboarding,
}: SettingsModalProps) {
  if (!open) return null;

  return (
    <div className="ds-modal-overlay" role="dialog" aria-modal="true" aria-label="Settings">
      <div className="ds-modal">
        <div className="ds-modal__head">
          <h3 className="ds-modal__title">Settings</h3>
          <button type="button" className="ds-btn ds-btn--sm ds-btn--ghost" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="ds-field">
          <span className="ds-field__label">Claude model</span>
          <input
            className="ds-field__input"
            value={model}
            onChange={(e) => onUpdateModel(e.target.value)}
            placeholder={DEFAULT_MODEL}
          />
        </div>

        <div className="ds-modal__actions">
          <button type="button" className="ds-btn ds-btn--ghost" onClick={onRerunOnboarding}>
            Re-run onboarding
          </button>
          <button type="button" className="ds-btn ds-btn--primary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
